import * as Fetch from '@/helpers/fetch'

export const verifyOtp = async (
  token: string,
  requestBody: any,
  step?: string
): Promise<Fetch.HttpResponse> => {
  const param = !step ? 'L1' : step
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/otp/verifications?step=${param}`
  const body = requestBody

  body['l1_token'] = param === 'L2' ? requestBody['l1_token'] : undefined

  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }
  try {
    const result = await Fetch.post(url, options)

    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const sendOtp = async (
  token: string,
  requestBody: any,
  step?: string
): Promise<Fetch.HttpResponse> => {
  const param = !step ? 'L1' : step
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/otp?step=${param}`
  const body = requestBody
  body['l1_token'] = param === 'L2' ? requestBody['l1_token'] : undefined
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }
  try {
    const result = await Fetch.post(url, options)

    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
